import React from 'react'
import { GlobalStyles, ResetStyles, FontStyles } from './Styles'

import { Main } from '../Components/Common/SemanticComponents'

const Layout: React.FunctionComponent = ({ children }) => (
  <>
    <ResetStyles />
    <GlobalStyles />
    <FontStyles />
    <Main>{children}</Main>
  </>
)

export default Layout
